export const parseUrl = (url) => {
  let resObj = {}
  let splitlist = url.split('?')
  if (splitlist && splitlist.length > 1) {
    let query = splitlist[1]
    var queryArr = query.split('&')
    queryArr.forEach(function (item) {
      var key = item.split('=')[0]
      var value = item.split('=')[1]
      resObj[key] = value
    })
  }
  return resObj
}

export const getShowUrlTypeName = (linkUrl) => {
  let showName = '全部'
  if (linkUrl && linkUrl.length) {
    let url = linkUrl
    let par = parseUrl(url)
    if (par.contentType) {
      switch (parseInt(par.contentType)) {
        case 51:
        case 52:
        case 53:
          showName = '视频'
          break
        case 61:
        case 62:
        case 63:
          showName = '图片'
          break
        case 44:
        case 43:
        case 41:
          showName = '文章'
          break
        case 25:
        case 26:
        case 27:
          showName = '文档'
          break
        case 81:
        case 82:
        case 83:
        case 84:
          showName = '名片'
          break
        case 91:
        case 92:
        case 93:
          showName = '动态'
          break
      }
    }
  }
  return showName
}

export const getShowUrlControlTypeName = (linkUrl) => {
  let showName = '全部'
  if (linkUrl && linkUrl.length) {
    let url = linkUrl
    let par = parseUrl(url)
    if (par.contentType) {
      switch (parseInt(par.contentType)) {
        case 51:
        case 52:
        case 53:
          showName = '上传视频'
          break
        case 61:
        case 62:
        case 63:
          showName = '上传图片'
          break
        case 44:
        case 43:
        case 41:
          showName = '新建文章'
          break
        case 25:
        case 26:
        case 27:
          showName = '新建文档'
          break
        case 81:
        case 82:
        case 83:
        case 84:
          showName = '拨打电话'
          break
        case 91:
        case 92:
        case 93:
          showName = '新建动态'
          break
      }
    }
  }
  return showName
}
